module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Deleted-file-9e7f761ba025351d860b1f481f66e1fd.svg";